import { useTranslation } from "react-i18next";
import { formatDate } from "../../../../utils/DateUtils";
import InviteStatus from "../../../../enums/InviteStatus";
import IInviteRecord from "../../../../models/invite/IInviteRecord";

interface IAccessStatusProps {
    invite: IInviteRecord;
}

const AccessStatus = (props: IAccessStatusProps) => {
    const { t } = useTranslation();

    switch (props.invite.status) {
        case InviteStatus.Queued:
        case InviteStatus.Processing:
            return (
                <span className="text-muted">
                    {t("it.invite.history.access.pending")}
                </span>
            );

        case InviteStatus.Failed:
            return (
                <span className="text-muted">
                    {t("it.invite.history.access.none")}
                </span>
            );

        case InviteStatus.Successful:
            return (
                <>
                    <span className="d-block small text-muted">
                        {t("it.invite.history.access.expires")}
                    </span>

                    {
                        !!props.invite.accessExpiresAt
                            ? formatDate(props.invite.accessExpiresAt)
                            : t("it.invite.history.access.indefinite")
                    }
                </>
            );
    }
};

export default AccessStatus;